import * as yup from 'yup';
import {
  investmentDateField,
  investmentTypeField,
  shareClassNameField,
  usdField,
  ViewModelInvestmentType,
} from './common-schema-defs';
import { abstractShareClassSchema } from './AbstractShareClass.schema';

export const DebtSchema = {
  create() {
    return abstractShareClassSchema().shape({
      type: investmentTypeField().default(ViewModelInvestmentType.debt),
      name: shareClassNameField().default('Debt'),
      cashRaised: usdField().required().label('Amount').default(0.0),
      investmentDate: investmentDateField(),
    });
  },
};

export type Debt = yup.InferType<ReturnType<typeof DebtSchema.create>>;
export function createDebt(overrides: Partial<Debt> = {}): Debt {
  return DebtSchema.create().cast(overrides);
}
